import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';
import { Programme } from '../models/programme';
import { ProgrammeCourse } from '../models/programmeCourse';
import { ProgrammeMember } from '../models/programmeMember';
import { Account } from '../models/account';

@Injectable({
  providedIn: 'root'
})

export class ProgrammeService {

    constructor(private http: HttpClient) {
    }

    public notifyMembers(programmeId:number):Observable<any>{
      return this.http.post(environment.apiEndpoint+'/api/programme/notifyMembers', {programmeId:programmeId}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public createProgramme(programme:Programme): Observable<Programme>{
        return this.http.post<Programme>(environment.apiEndpoint + `/api/programme`,programme).pipe(
            map(res => {
                return new Programme(res);
            })
        );
    }

    public updateProgramme(programme:Programme): Observable<Programme>{
        return this.http.put<Programme>(environment.apiEndpoint + `/api/programme`,programme).pipe(
            map(res => {
                return new Programme(res);
            })
        );
    }

    public deleteProgramme(programme:Programme): Observable<Programme>{
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
            body: programme,
        };
        return this.http.delete<any>(environment.apiEndpoint + `/api/programme`,options).pipe(
            map(res => {
                return res;
            })
        );
    }

    public deletePTP(id:number):Observable<any>{
      return this.http.delete(environment.apiEndpoint+`/api/programme/${id}`).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public addCourse(programmeCourse:ProgrammeCourse): Observable<ProgrammeCourse>{
        return this.http.post<ProgrammeCourse>(environment.apiEndpoint + `/api/programme/course`,programmeCourse).pipe(
            map(res => {
                return new ProgrammeCourse(res);
            })
        );
    }

    public deleteCourse(programmeCourse:ProgrammeCourse): Observable<ProgrammeCourse>{
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
            body: programmeCourse,
        };
        return this.http.delete<ProgrammeCourse>(environment.apiEndpoint + `/api/programme/course`,options).pipe(
            map(res => {
                return res;
            })
        );
    }

    public addMembers(programmeMembers:[],programme_id:number): Observable<ProgrammeMember>{
        return this.http.post<ProgrammeMember>(environment.apiEndpoint + `/api/programme/member`,{members:programmeMembers,programme_id:programme_id}).pipe(
            map(res => {
                return new ProgrammeMember(res);
            })
        );
    }

    public deleteMember(programmeMember:ProgrammeMember): Observable<ProgrammeMember>{
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
            body: programmeMember,
        };
        return this.http.delete<ProgrammeMember>(environment.apiEndpoint + `/api/programme/member`,options).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getProgramme(id:number):Observable<any>{
      return this.http.get<any>(environment.apiEndpoint+'/api/programme/'+id).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getMyProgrammes(include_course_data:boolean=false): Observable<any>{
        return this.http.get<any>(environment.apiEndpoint + `/api/my-programmes/` + include_course_data).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getMyProgrammesLight(include_course_data:boolean=false): Observable<any>{
      return this.http.get<any>(environment.apiEndpoint + `/api/my-programmes-light/` + include_course_data).pipe(
          map(res => {
              return res;
          })
      );
  }

    public getMyProgrammesPlusMetas(): Observable<any>{
      return this.http.get<any>(environment.apiEndpoint + `/api/my-programmes-plus-metas`).pipe(
          map(res => {
              return res;
          })
      );
  }

    public getMemberProgrammes(include_course_data?:boolean): Observable<iHttpPaginatedResponse>{
        return this.http.get<any>(environment.apiEndpoint + `/api/member-programmes/` + include_course_data).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getMemberProgrammesPlusMetas(): Observable<any>{
      return this.http.get<any>(environment.apiEndpoint + `/api/member-programmes-plus-metas`).pipe(
          map(res => {
              return res;
          })
      );
  }

    public getProgrammeMembers(programme_id:number): Observable<any>{
        return this.http.get<any>(environment.apiEndpoint + `/api/programme/member/${programme_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getProgrammeCourses(programme_id): Observable<any>{
        return this.http.get<any>(environment.apiEndpoint + `/api/programme/course/${programme_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }
}